"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BrandsCtxItemImgNew_1 = require("./BrandsCtxItemImgNew");
var BrandsCtxItemImg_1 = require("./BrandsCtxItemImg");
var BrandsCtxItemImgBack_1 = require("./BrandsCtxItemImgBack");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var BrandsCtxAreaImg = /** @class */ (function (_super) {
    __extends(BrandsCtxAreaImg, _super);
    function BrandsCtxAreaImg(props) {
        return _super.call(this, props) || this;
    }
    BrandsCtxAreaImg.prototype.componentWillMount = function () {
        var _this = this;
        var dList = this.props.data.getBrandItemById(this.props.brandId).directories;
        var canBreak = false;
        this.setState({ dirList: dList });
        for (var i = 0; i < dList.length; i++) {
            if (canBreak) {
                break;
            }
            if (dList[i].dirName === this.props.dirName) {
                this.setState({
                    dir: dList[i]
                }, function () {
                    canBreak = true;
                });
            }
        }
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            dList = _this.props.data.getBrandItemById(_this.props.brandId).directories;
            canBreak = false;
            _this.setState({ dirList: dList });
            for (var i = 0; i < dList.length; i++) {
                if (canBreak) {
                    break;
                }
                if (dList[i].dirName === _this.props.dirName) {
                    _this.setState({
                        dir: dList[i]
                    }, function () {
                        canBreak = true;
                    });
                }
            }
        });
    };
    BrandsCtxAreaImg.prototype.componentWillReceiveProps = function (nextProps) {
        var dirList = nextProps.data.getBrandItemById(nextProps.brandId).directories;
        var canBreak = false;
        for (var i = 0; i < dirList.length; i++) {
            if (canBreak) {
                break;
            }
            if (dirList[i].dirName === nextProps.dirName) {
                this.setState({
                    dir: dirList[i]
                }, function () {
                    canBreak = true;
                });
            }
        }
    };
    BrandsCtxAreaImg.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BrandsCtxAreaImg.prototype.deleteDirClick = function (brandId, dirName, fileName) {
        var _this = this;
        this.props.yesNoDlg
            .SetTitle("Удалить изображение ?")
            .SetMessage("\u0423\u0434\u0430\u043B\u0438\u0442\u044C " + fileName + " ?")
            .SetOnNoClick(function () { _this.props.yesNoDlg.Close(); })
            .SetOnYesClick(function () {
            _this.props.data.DeleteFile(_this.props.data.getBrandItemById(brandId), _this.props.data.getDirectoryItemByName(_this.props.data.getBrandItemById(brandId), dirName), fileName, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 ",
                    React.createElement("b", null,
                        "[",
                        fileName,
                        "]"),
                    " \u0431\u044B\u043B\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u043E"));
            });
        })
            .Show();
    };
    BrandsCtxAreaImg.prototype.editImageClick = function (brandId, dirName, fileName) {
        if (this.props.onEditImage) {
            this.props.onEditImage(brandId, dirName, fileName);
        }
    };
    BrandsCtxAreaImg.prototype.createImageClick = function (brandId) {
        if (this.props.onCreateImage) {
            this.props.onCreateImage(brandId, this.props.dirName);
        }
    };
    BrandsCtxAreaImg.prototype.getRenderObjectList = function () {
        var _this = this;
        var _ret = [];
        _ret.push(React.createElement(BrandsCtxItemImgBack_1.default, { title: "\u041D\u0430\u0437\u0430\u0434", brandId: this.props.brandId, key: "back-" + this.props.brandId + "-dir}", onBackClick: function (brandId) {
                if (_this.props.onGoBackClick) {
                    _this.props.onGoBackClick(brandId);
                }
            } }));
        _ret.push(React.createElement(BrandsCtxItemImgNew_1.default, { title: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C", brandId: this.props.brandId, key: "new-" + this.props.brandId + "-dir}", onNewClick: this.createImageClick.bind(this) }));
        for (var i = 0; i < this.state.dir.files.length; i++) {
            _ret.push(React.createElement(BrandsCtxItemImg_1.default, { dirName: this.state.dir.dirName, fileName: this.state.dir.files[i].fileName, cdnUrl: this.props.data.DATA.cdn_baseurl, brand: this.props.data.getBrandItemById(this.props.brandId), key: "img-" + this.props.brandId + "-" + this.state.dir.files[i].fileName, onDeleteClick: this.deleteDirClick.bind(this), onEditClick: this.editImageClick.bind(this), mode: "edit" }));
        }
        return _ret;
    };
    BrandsCtxAreaImg.prototype.render = function () {
        return (React.createElement("div", { style: {
                width: "100%",
                borderColor: "black",
                borderStyle: "solid",
                borderLeftWidth: "0px",
                borderTopWidth: "1px",
                borderRightWidth: "1px",
                borderBottomWidth: "1px",
                display: "flex",
                justifyContent: "flex-start",
                alignContent: "flex-start",
                alignItems: "flex-start",
                justifyItems: "flex-start",
                flexDirection: "row",
                flexWrap: "wrap",
                overflowY: "scroll",
                overflowX: "hidden"
            } }, this.getRenderObjectList()));
    };
    return BrandsCtxAreaImg;
}(React.Component));
exports.default = BrandsCtxAreaImg;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_images/ui/component/controls/BrandsCtxAreaImg.tsx
// module id = 2370
// module chunks = 0